<template>
  <div>
    <div v-if="isMobile">
      <challenge-mobile
        :challenge="challenge"
        :timer="timer"
        :momentImages="momentImages"
        :icons="icons"
        @claim="claimPrize"
      />
    </div>

    <div
      v-else
      class="background"
      :style="'background-image: url(' + Background + ')'"
    >
      <challenge-desktop
        :challenge="challenge"
        :timer="timer"
        :momentImages="momentImages"
        :icons="icons"
        @claim="claimPrize"
      />
    </div>

    <ClaimChallengeDialog v-model="claimDialog" :challenge="challenge" />
  </div>
</template>

<script>
  import Background from '@/assets/challenges/background.jpg';
  import ChallengesController from '@/controllers/ChallengesController';
  import IVE_Image from '@/assets/challenges/ive.png';
  import KITSCH_Image from '@/assets/challenges/kitsch.png';
  import CollectedIcon from '@/assets/challenges/collected_icon.png';
  import UncollectedIcon from '@/assets/challenges/uncollected_icon.png';

  import IVE_I from '@/assets/challenges/ive/I.png';
  import IVE_V from '@/assets/challenges/ive/V.png';
  import IVE_E from '@/assets/challenges/ive/E.png';
  import KITSCH_K from '@/assets/challenges/kitsch/K.png';
  import KITSCH_I from '@/assets/challenges/kitsch/I.png';
  import KITSCH_T from '@/assets/challenges/kitsch/T.png';
  import KITSCH_S from '@/assets/challenges/kitsch/S.png';
  import KITSCH_C from '@/assets/challenges/kitsch/C.png';
  import KITSCH_H from '@/assets/challenges/kitsch/H.png';

  export default {
    name: 'Homes',

    components: {
      ChallengeDesktop: () => import('./ChallengeDesktop.vue'),
      ChallengeMobile: () => import('./ChallengeMobile.vue'),
      ClaimChallengeDialog: () =>
        import('../../Claims/ClaimChallengeDialog.vue'),
    },

    props: ['isMobile'],

    data: () => ({
      icons: { CollectedIcon, UncollectedIcon },
      challenge: null,
      timer: null,
      images: {
        ive: IVE_Image,
        kitsch: KITSCH_Image,
      },
      momentImages: {
        ive: {
          'IVE - I': IVE_I,
          'IVE - V': IVE_V,
          'IVE - E': IVE_E,
        },
        kitsch: {
          'KITSCH - K': KITSCH_K,
          'KITSCH - I': KITSCH_I,
          'KITSCH - T': KITSCH_T,
          'KITSCH - S': KITSCH_S,
          'KITSCH - C': KITSCH_C,
          'KITSCH - H': KITSCH_H,
        },
      },
      Background,
      timeElapsed: 0,
      timerInterval: undefined,
      timeLimit: 10000,
      claimDialog: false,
      claimMessage:
        "Congratulations! We're processing your request to claim the prize. We'll contact you via registered email address for further instruction.",
    }),

    watch: {
      timeElapsed() {
        const timeLeft = new Date(this.challenge.expiryDate) - Date.now();
        const daysLeft = Math.floor(timeLeft / (24 * 60 * 60 * 1000));
        const hoursLeft = Math.floor(
          (timeLeft % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
        );
        const minutesLeft = Math.floor(
          (timeLeft % (60 * 60 * 1000)) / (60 * 1000)
        );
        const secondsLeft = Math.floor((timeLeft % (60 * 1000)) / 1000);
        this.timer = {
          timeLeft,
          daysLeft: daysLeft < 10 ? `0${daysLeft}` : daysLeft,
          hoursLeft: hoursLeft < 10 ? `0${hoursLeft}` : hoursLeft,
          minutesLeft: minutesLeft < 10 ? `0${minutesLeft}` : minutesLeft,
          secondsLeft: secondsLeft < 10 ? `0${secondsLeft}` : secondsLeft,
        };
      },
    },

    computed: {
      challengeId() {
        return this.$route.params.challengeId;
      },
    },

    mounted() {
      this.getChallenge();
      this.startTimer();
    },

    methods: {
      getChallenge: async function() {
        try {
          const challenge = await ChallengesController.getChallenge(
            this.challengeId
          );
          if (challenge.imageUrl) {
            challenge.image = challenge.imageUrl;
          } else {
            challenge.image = this.images[challenge.challengeId];
          }
          this.challenge = challenge;
        } catch (err) {
          this.$emit('handleError', err);
        }
      },
      startTimer() {
        this.timerInterval = setInterval(() => {
          if (++this.timeElapsed === this.timeLimit) {
            clearInterval(this.timerInterval);
          }
        }, 1000);
      },
      claimPrize: async function() {
        this.claimDialog = true;
      },
    },
  };
</script>

<style>
  .overlapImage {
    top: 0% !important;
    left: 0% !important;
    width: 100% !important;
    height: 100% !important;
  }

  .greyscaleImage {
    filter: grayscale(0.95) !important;
    filter: brightness(0.15) !important;
  }

  .momentStatusCollected {
    background: #ff8dd8 !important;
    border-radius: 8px;
    color: #ebebeb !important;
    font-family: 'Work Sans';
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    letter-spacing: 0.001em !important;
    pointer-events: none;
  }

  .momentStatusUncollected {
    background: #c0c0c0 !important;
    border-radius: 8px;
    color: #ebebeb !important;
    font-family: 'Work Sans';
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    letter-spacing: 0.001em !important;
    pointer-events: none;
  }

  .momentTitle {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 24px !important;
    line-height: 32px !important;
    color: #000000;
    text-transform: capitalize;
  }

  .momentInfo {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    letter-spacing: 0.001em !important;
    color: #151515;
  }
</style>
